var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.292 21.772c-.137.147-5.282.218-10.927.227h-2.559l-.852-.002c-4.27-.012-8.312-.058-10.195-.133a91.475 91.475 0 0 0 8.077-3.527c4.151-2.045 8.129-4.673 11.933-7.884 2.647 5.782 4.8 11.023 4.523 11.32ZM15.131.002c.477.096 1.585 1.849 4.127 7.207-3.68 3.778-7.522 6.907-11.525 9.387a103.983 103.983 0 0 1-7.734 4.37c.653-1.196 2.14-3.565 3.786-6.08l.364-.554c.183-.278.367-.557.552-.835l.37-.555c1.048-1.57 2.09-3.094 2.966-4.326 3.194-4.492 6.577-8.718 7.094-8.614Z",
    fill: "current",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e2a233058543a54a9e2062a9dd1a235.svg";
export { ForwardRef as ReactComponent };